import axios from 'axios';

function logError(data) {
  axios.post(
    'https://hook.integromat.com/oi7ku58j89trel3lffrvqoyc88dryn6n',
    data,
  );
}

export { logError, };